import db from './db';

function normalizeValue(value) {
  return String(value ?? '').trim();
}

function dedupeAddressItems(items = []) {
  const seen = new Set();

  return items.filter((item) => {
    const key = [
      item?.id,
      item?.companyId,
      item?.addressCompany,
      item?.companyName,
      item?.addressCode,
      item?.name,
    ]
      .map(normalizeValue)
      .join('||');

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
}

function dedupeClientMenuItems(items = []) {
  const seen = new Set();

  return items
    .map((item) => ({
      ...item,
      itemsData: Array.isArray(item?.itemsData)
        ? dedupeAddressItems(item.itemsData)
        : item?.itemsData,
    }))
    .filter((item) => {
      const key = [
        item?.id,
        item?.companyId,
        item?.addressCompany,
        item?.companyCode,
        item?.companyName,
        item?.addressCode,
        item?.addressName,
        item?.name,
        item?.contactIndex,
      ]
        .map(normalizeValue)
        .join('||');

      if (seen.has(key)) {
        return false;
      }

      seen.add(key);
      return true;
    });
}

export default function createLocalStoragePlugin({
  moduleName,
  localStorageName,
}) {
  return async (store) => {
    let clientMenu = {
      currentAddress: '',
      items: [],
    };

    const localStorageState = localStorage.getItem(localStorageName);
    if (localStorageState !== null) {
      clientMenu = JSON.parse(localStorageState);
    }

    const contacts = db.contacts.toArray();
    const headquarters = db.headquarters.toArray();

    await Promise.all([contacts, headquarters]).then((values) => {
      const items = dedupeClientMenuItems([
        ...values[0],
        ...values[1],
      ]);

      if (items.length > 0) {
        clientMenu.items = items;

        store.replaceState({
          ...store.state,
          [moduleName]: clientMenu,
        });
      }
    });

    store.subscribe((mutation, state) => {
      if (mutation.type === 'clientMenu/setCurrentAddress') {
        localStorage.setItem(
          localStorageName,
          JSON.stringify({
            currentAddress: mutation.payload,
            items: [],
          })
        );
      }
    });
  };
}
